







import { Component, Vue } from 'vue-property-decorator';
import API from '@/Api';

@Component
export default class ShiftTiming extends Vue {
    // public title: string = '';
    public items: any = null;

    public mounted() {
        // API.Instance
        // .get('/api/shift-timing')
        // .then((response) => {
        //     this.title = response.data;
        // });
        this.load();
    }
    public load() {
        API.Instance
        .get('/api/payroll-closing-date/getManagerClosingDate')
        .then((res) => {
            this.items = res.data;
        });
    }
}
